import { Link } from 'react-router'
import { Logo } from '../components/ui'

export function NotFound() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 px-4 text-center">
      <Logo />
      <h1 className="font-head text-3xl font-semibold tracking-tight">This page doesn't exist</h1>
      <p className="text-muted">The link may be old, or the address has a typo.</p>
      <div className="flex gap-3">
        <Link to="/" className="btn btn-ghost">
          Home
        </Link>
        <Link to="/app" className="btn btn-primary">
          Open dashboard
        </Link>
      </div>
    </main>
  )
}
